// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./search-plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./search-minus.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-photo {
  position: fixed;
  inset: 0;
  background-color: rgba(var(--white));
  z-index: 10;
  overflow: hidden;
  animation: 0.3s show ease;
}
.modal-photo__close {
  position: absolute;
  top: 2rem;
  right: 2rem;
}
.modal-photo__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  height: 100vh;
  width: calc(100vw - 40rem);
}
.modal-photo__active-img {
  width: 100% !important;
  animation: 0.3s show2 ease;
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), auto !important;
  display: none !important;
}
.modal-photo__active-img_show {
  display: inline-block !important;
}
.modal-photo__active-img.zoomed {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), auto !important;
}
.modal-photo__scroll {
  position: relative;
  height: 0.25rem;
  width: 100%;
  background-color: rgba(var(--blue-grey-300));
  margin: 0.6875rem 2rem 0.6875rem 0.5rem;
}
.modal-photo__scroll-wrapper {
  display: flex;
  width: 100%;
  margin-top: 2rem;
}
.modal-photo__scroll-label {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.625;
  color: rgba(var(--grey-600));
  white-space: nowrap;
}
.modal-photo__scroll-item {
  position: absolute;
  height: 0.25rem;
  transition: transform 500ms ease-in-out;
  background-color: rgba(var(--grey-600));
}
.modal-photo__arrow-right {
  position: absolute;
  right: -5rem;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.modal-photo__arrow-right_show {
  cursor: pointer !important;
  opacity: 1;
}
.modal-photo__arrow-left {
  position: absolute;
  transform: rotateY(180deg);
  left: -5rem;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.modal-photo__arrow-left_show {
  cursor: pointer !important;
  opacity: 1;
}

#imageZoom {
  object-fit: cover;
  height: calc(100vh - 14rem);
  transition: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/ModalPhoto/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,oCAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,0BAAA;AAAJ;AAGE;EACE,sBAAA;EACA,0BAAA;EACA,gEAAA;EACA,wBAAA;AADJ;AAGI;EACE,gCAAA;AADN;AAII;EACE,gEAAA;AAFN;AAME;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,4CAAA;EACA,uCAAA;AAJJ;AAMI;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AAJN;AAOI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;AALN;AAQI;EACE,kBAAA;EACA,eAAA;EACA,uCAAA;EACA,uCAAA;AANN;AAWI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gCAAA;AATN;AAWM;EACE,0BAAA;EACA,UAAA;AATR;AAaI;EACE,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,UAAA;EACA,gCAAA;AAXN;AAaM;EACE,0BAAA;EACA,UAAA;AAXR;;AAiBA;EACE,iBAAA;EACA,2BAAA;EACA,2BAAA;AAdF","sourcesContent":[".modal-photo {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(var(--white));\n  z-index: 10;\n  overflow: hidden;\n  animation: 0.3s show ease;\n\n  &__close {\n    position: absolute;\n    top: 2rem;\n    right: 2rem;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    margin: 0 auto;\n    height: 100vh;\n    width: calc(100vw - 40rem);\n  }\n\n  &__active-img {\n    width: 100% !important;\n    animation: 0.3s show2 ease;\n    cursor: url('./search-plus.svg'), auto !important;\n    display: none !important;\n\n    &_show {\n      display: inline-block !important;\n    }\n\n    &.zoomed {\n      cursor: url('./search-minus.svg'), auto !important;\n    }\n  }\n\n  &__scroll {\n    position: relative;\n    height: 0.25rem;\n    width: 100%;\n    background-color: rgba(var(--blue-grey-300));\n    margin: 0.6875rem 2rem 0.6875rem 0.5rem;\n\n    &-wrapper {\n      display: flex;\n      width: 100%;\n      margin-top: 2rem;\n    }\n\n    &-label {\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.625;\n      color: rgba(var(--grey-600));\n      white-space: nowrap;\n    }\n\n    &-item {\n      position: absolute;\n      height: 0.25rem;\n      transition: transform 500ms ease-in-out;\n      background-color: rgba(var(--grey-600));\n    }\n  }\n\n  &__arrow {\n    &-right {\n      position: absolute;\n      right: -5rem;\n      opacity: 0;\n      transition: all 0.3s ease-in-out;\n\n      &_show {\n        cursor: pointer !important;\n        opacity: 1;\n      }\n    }\n\n    &-left {\n      position: absolute;\n      transform: rotateY(180deg);\n      left: -5rem;\n      opacity: 0;\n      transition: all 0.3s ease-in-out;\n\n      &_show {\n        cursor: pointer !important;\n        opacity: 1;\n      }\n    }\n  }\n}\n\n#imageZoom {\n  object-fit: cover;\n  height: calc(100vh - 14rem);\n  transition: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
